Date.prototype.__defineGetter__('mysqlUTCTimestamp', function () {
    // tslint:disable-next-line:no-this-assignment
    let date = this;
    if (!isValidDate(this))
        date = new Date();
    return date.toISOString().substring(0, 19).replace('T', ' ');
});
Date.prototype.__defineGetter__('mysqlTimestamp', function () {
    const timezoneOffset = new Date().getTimezoneOffset() * 60000;
    const utcDate = new Date(this - timezoneOffset);
    return utcDate.mysqlUTCTimestamp;
});
function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
}
